<template>
  <el-row class="container-card">
    <el-col>
      <div class="flex-start profile-tabs position-relative">
        <div class="profile-tab pointer active">
          <p>Help desk</p>
        </div>
      </div>
      <el-card class="position-relative" v-loading="loading">
        <div class="profile-content">
          <div class="help-desk">
            <el-form>
              <el-form-item>
                <el-input
                  maxlength="50"
                  placeholder="Subject"
                  autocomplete="off"
                  v-model="subject"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  class="textarea"
                  type="textarea"
                  resize="none"
                  placeholder="Text"
                  autocomplete="off"
                  maxlength="255"
                  v-model="text"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button
              type="primary"
              class="btn-main float-right ml-auto"
              @click="submitMessage"
            >
              Submit
            </el-button>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      subject: '',
      text: '',
      url: process.env.VUE_APP_STORAGE_URL,
      formLabelWidth: '165px',
      description: ''
    }
  },

  created() {
    this.readLabel().then(() => {
      this.description = this.label.description
    })
  },

  computed: {
    ...mapState('labelMyProfile', ['label', 'loading'])
  },

  methods: {
    ...mapActions('labelMyProfile', [
      'readLabel',
      'updateDescription',
      'sendMessage'
    ]),
    submitDescription() {
      this.updateDescription(this.description)
    },
    submitMessage() {
      let fullMessage = {
        subject: this.subject,
        text: this.text
      }
      this.sendMessage(fullMessage)
      this.text = ''
      this.subject = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-tabs {
  height: 58px;
  .profile-tab {
    width: 190px;
    height: 70px;
    background: white;
    display: flex;
    justify-content: center;
    border-radius: 10px 10px 0 0;
    font-size: 20px;
    z-index: 0;
    box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.17);
    font-family: 'F37 Ginger Pro Bold';
    &.active {
      background: #e6e5e8;
      color: #d40c41;
    }
  }
}

.data {
  z-index: 2;
  position: relative;
  height: 560px;
}

.profile-content {
  padding: 0 30px;
  p {
    font-size: 16px;
  }
  p.title {
    font-size: 20px;
    font-family: 'F37 Ginger Pro Bold';
  }
  .social-networks {
    width: 86%;
  }
  .btn-main {
    align-self: flex-end;
    margin-bottom: 8px;
  }
  .member {
    width: 100%;
    height: 65px;
    border-radius: 10px;
    border: 1px solid grey;
    margin-bottom: 6px;
    img {
      padding: 0 20px;
    }
    p {
      margin: 0;
    }
    .email,
    .status {
      font-size: 12px;
    }
    .status {
      margin-left: auto;
      padding-right: 65px;
    }
  }
}
</style>
